import { useMemo } from 'react';
import DateCell from 'views/root/views/home/views/activity/views/incidents/useTableData/cells/DateCell';
import StateCell from './cells/StateCell';
import DeleteCell from './cells/DeleteCell';
import { StyledCell } from 'components/base/Table/Table.styles';

const useTokensTable = ({ multiTokens }) => {
  const cols = useMemo(() => {
    return [
      {
        dataPoint: 'index_cell',
        name: 'ID'
      },
      {
        dataPoint: 'created_at_cell',
        name: 'CREATED AT',
        sortPoint: 'created_at',
        isSortedCol: true
      },
      {
        dataPoint: 'profile_cell',
        name: 'PROFILE'
      },
      {
        dataPoint: 'state_cell',
        name: 'STATE',
        sortPoint: 'state',
        isSortedCol: true
      },
      {
        dataPoint: 'delete_cell',
        name: ''
      }
    ];
  }, []);

  const rows = useMemo(() => {
    return multiTokens.tokensList.map((token, idx) => {
      return {
        ...token,
        index_cell: <StyledCell>{idx + 1}</StyledCell>,
        created_at_cell: <DateCell date={token.created_at} />,
        profile_cell: <StyledCell>{token.profile?.username || ''}</StyledCell>,
        state_cell: <StateCell token={token} />,
        delete_cell: (
          <DeleteCell onDelete={() => multiTokens.deleteToken(token.id)} />
        )
      };
    });
  }, [multiTokens.tokensList]);

  return { rows, cols };
};

export default useTokensTable;
